export enum BaseballIncidentId {
  TVTimeout = 2,
  // Game status incidents
  MatchAboutToStart = 2762,
  NotStarted = 543,
  StartDelayed = 551,
  DelayedByRain = 394,
  FirstInningStarted = 532,
  BreakAfterFirstInning = 2499,
  SecondInningStarted = 533,
  BreakAfterSecondInning = 2500,
  ThirdInningStarted = 534,
  BreakAfterThirdInning = 2501,
  FourthInningStarted = 535,
  BreakAfterFourthInning = 2502,
  FifthInningStarted = 536,
  BreakAfterFifthInning = 2503,
  SixthInningStarted = 537,
  BreakAfterSixthInning = 2504,
  SeventhInningStarted = 538,
  BreakAfterSeventhInning = 2505,
  EighthInningStarted = 539,
  BreakAfterEighthInning = 2506,
  NinthInningStarted = 540,
  BreakAfterNinthInning = 2507,
  TenthInningStarted = 566,
  BreakAfterTenthInning = 2508,
  EleventhInningStarted = 567,
  BreakAfterEleventhInning = 2509,
  TwelfthInningStarted = 568,
  BreakAfterTwelfthInning = 2510,
  ThirteenthInningStarted = 569,
  BreakAfterThirteenthInning = 2511,
  FourteenthInningStarted = 570,
  BreakAfterFourteenthInning = 2512,
  FifteenthInningStarted = 571,
  BreakAfterFifteenthInning = 2513,
  SixteenthInningStarted = 572,
  BreakAfterSixteenthInning = 2514,
  SeventeenthInningStarted = 573,
  BreakAfterSeventeenthInning = 2515,
  EighteenthInningStarted = 574,
  BreakAfterEighteenthInning = 2516,
  NineteenthInningStarted = 575,
  BreakAfterNineteenthInning = 2517,
  TwentiethInningStarted = 576,
  BreakAfterTwentiethInning = 2518,
  TwentyFirstInningStarted = 578,
  BreakAfterTwentyFirstInning = 2519,
  TwentySecondInningStarted = 579,
  BreakAfterTwentySecondInning = 2520,
  TwentyThirdInningStarted = 580,
  BreakAfter = 2498,
  BreakDuringTheGame = 2938,
  FinishedAwardedWin = 546,
  FinishedRegularTime = 547,
  Cancelled = 548,
  Postponed = 549,
  Interrupted = 550,
  Abandoned = 552,
  CancelledDueRain = 564,
  ToFinish = 565,
  ResetStats = 577,
  FinishedAfterExtraInning = 2531,
  UnderReview = 2937,

  // Play incidents
  Run = 501,
  ThrowPitcher = 502,
  Strike = 503,
  Ball = 504,
  Foul = 505,
  InPlayRun = 506,
  Error = 509,
  HomeRun = 519,
  Strikeout = 520,
  Out = 521,
  CaughtStealing = 527,
  StolenBase = 528,
  Walk = 553,
  HitByPitch = 554,
  SwingAndMiss = 558,
  PitcherChange = 559,
  Hit = 562,
  PlateAppearance = 563,
  ResetStatsInBoxBallsStrikes = 2521,
  PickOffAttempt = 2522,
  InPlay = 2523,
  InPlayOut = 2524,
  DoublePlay = 2525,
  TriplePlay = 2526,
  WildPitch = 2527,
  BatterChange = 2939,
  FirstBase = 2940,
  SecondBase = 2941,
  ThirdBase = 2942,
  FirstBaseOff = 2943,
  SecondBaseOff = 2944,
  ThirdBaseOff = 2945,
}
